import React, { useState, useCallback, useMemo } from "react";
import Button from "../../Components/Button/Button";
import Modal from "../../Components/Modal/Modal";
import { useSpacePost } from "../../Helpers/IOClient";
import { ExtraCloseButton } from "../../Components/FilePreviewer/FilePreviewer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInboxOut } from "@fortawesome/pro-light-svg-icons";
import InformationComponent from "../../Components/InformationComponent/InformationComponent";
import { FormattedMessage, useIntl } from "react-intl";
import { handleError } from "../../Helpers/MiscHelper";
import { useToast } from "../../Components/Toast/ToastProvider";
import Input from "../../Components/Input/Input";
import LoadableButton from "../../Components/Button/LoadableButton";
import { useCurrentAccount } from "../../Contexts/UserContext";
import { isDeveloper } from "../../Helpers/ModulesHelper";

function refetchEmailConv() {
  const btn = document.getElementById("conv-refetch-emails");
  if (btn) btn.click();
}

const ForwardEmailModal = ({ emailConversationId, emailId, handleClosure }) => {
  const [email, setEmail] = useState("");
  const [message, setBody] = useState("");

  const forwardURL = useMemo(
    () => `EmailConversation/${emailConversationId}/${emailId}/Forward`,
    [emailConversationId, emailId]
  );
  const intl = useIntl();
  const createToast = useToast();

  const [post, { loading }] = useSpacePost(forwardURL, null, {
    onSuccess: () => {
      createToast({
        pos: "tm",
        type: "success",
        description: `${intl.formatMessage({
          id: "EMAIL_FORWARD_SUCCESS"
        })}`
      });

      refetchEmailConv();
      handleClosure();
    },
    onError: (error) => {
      handleError(createToast, error);
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    post({
      email,
      message
    });
  };

  return (
    <div className="bg-white p-4 rounded w90-header">
      <div className="d-flex fs-18 fw-bold justify-content-center mb-3 text-black">
        <FormattedMessage id="FORWARD_EMAIL"></FormattedMessage>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mb-2">
          <div className="mb-1 fs-14 w-100 fw-medium disable-selection text-black">
            <FormattedMessage id="EMAIL_TO"></FormattedMessage>
          </div>
          <Input
            type="email"
            multiple
            autoComplete="off"
            spellCheck="false"
            autoCorrect="off"
            autoCapitalize="none"
            placeholder="example1@airdesk.ai, example2@airdesk.ai"
            required
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div className="mb-4">
          <textarea
            className="ssi-input ssi-control air-reception-forwardemailtextarea"
            style={{ height: 120 }}
            autoComplete="false"
            required
            onChange={(e) => {
              setBody(e.target.value);
            }}
          />
        </div>

        <div className="w-100 d-flex justify-content-end">
          <LoadableButton
            type="submit"
            isLoading={loading}
            disabled={loading}
            vType="primary"
          >
            <FormattedMessage id="SEND" />
          </LoadableButton>
        </div>
      </form>
    </div>
  );
};

const ForwardEmailButton = ({ emailConversationId, emailId, className }) => {
  const [open, setOpen] = useState(false);

  const handleClosure = useCallback(() => {
    setOpen(false);
  }, []);

  //const currentAccont = useCurrentAccountSpace();
  const user = useCurrentAccount();
  const isUserDev = isDeveloper(user);

  //const canSendEmail = hasEmailConversationEditPermission(currentAccont);

  if (!isUserDev) return <></>;

  return (
    <>
      <Modal
        extraCloseButton={<ExtraCloseButton onClose={handleClosure} />}
        className="d-flex align-items-center of-visible justify-content-center"
        isOpen={open}
        enableCloseButton
        onClose={handleClosure}
      >
        <ForwardEmailModal
          emailConversationId={emailConversationId}
          emailId={emailId}
          handleClosure={handleClosure}
        />
      </Modal>
      <InformationComponent
        text={<FormattedMessage id="FORWARD" />}
        Component={
          <Button
            style={{ height: "auto" }}
            vType="link-primary"
            className={className}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faInboxOut} />
          </Button>
        }
      />
    </>
  );
};

export default ForwardEmailButton;
